import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormlyModule} from '@ngx-formly/core';
import {ReactiveFormsModule} from '@angular/forms';

import {FormlyFieldQuantityComponent} from './formly-field-quantity.component';
import {I18nModule} from '@spartacus/core';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'quantity',
          component: FormlyFieldQuantityComponent,
        },
      ],
    }),
    FormlyFieldQuantityComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FormlyQuantityModule {}
